export const isValidEmail = (email: string): boolean => {
  if (!email) return false;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

  return emailRegex.test(email.trim());
};

export const isEmpty = (value: string): boolean => {
  return !value || value.trim().length === 0;
};
